import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=bb2a99dc&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb2a99dc')) {
      api.createRecord('bb2a99dc', component.options)
    } else {
      api.reload('bb2a99dc', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=bb2a99dc&", function () {
      api.rerender('bb2a99dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UHtvHmy1h2xy/JS/offershelp.vue"
export default component.exports